import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'TrainingPrograms';

const TrainingProgramsApi: any = baseApi(endpoint);

export default TrainingProgramsApi;